import Konva from "konva";
import { Factory } from 'konva/lib/Factory.js';

export default class ClassConfigurator{
    static configureClasses(){
        this.#configureTextClass();
        this.#configureTexPathClass();
    }

    static #configureTextClass(){
        Factory.addGetterSetter(Konva._Text, 'maxChars', 0);
        Factory.addGetterSetter(Konva._Text, 'maxLines', 0);
        Factory.addGetterSetter(Konva._Text, 'sentence', 0);
        Factory.addGetterSetter(Konva._Text, 'sentence_author', 0);
        Factory.addGetterSetter(Konva._Text, 'texture_src', '');
        Factory.addGetterSetter(Konva._Text, 'texture_type', "");
        Factory.addGetterSetter(Konva._Text, 'texture_enabled', true);
        Factory.addGetterSetter(Konva._Text, 'textJSON', {})
        Factory.addGetterSetter(Konva._Text, 'rotate_texture', "0");
        Factory.addGetterSetter(Konva._Text, 'minFontSize', '28');
        Factory.addGetterSetter(Konva._Text, 'maxFontSize', '28');
        Factory.addGetterSetter(Konva._Text, 'innerShadowEnabled', false);
        Factory.addGetterSetter(Konva._Text, 'innerShadowColor', '#000000');
        Factory.addGetterSetter(Konva._Text, 'innerShadowOffsetX', '1');
        Factory.addGetterSetter(Konva._Text, 'innerShadowOffsetY', '1');
        Factory.addGetterSetter(Konva._Text, 'innerShadowOpacity', '0.5');
        Factory.addGetterSetter(Konva._Text, 'innerShadowBlur', '2');
        Factory.addGetterSetter(Konva._Text, 'myRotation', 0);
        Factory.addGetterSetter(Konva._Text, 'verticalAlign', 'top');
        Factory.addGetterSetter(Konva._Text, 'fontGroup', 0);
        Factory.addGetterSetter(Konva._Text, 'font_label', 0);
    }

    static #configureTexPathClass(){
        Factory.addGetterSetter(Konva._TextPath, 'maxChars', 0);
        Factory.addGetterSetter(Konva._TextPath, 'maxLines', 0);
        Factory.addGetterSetter(Konva._TextPath, 'sentence', 0);
        Factory.addGetterSetter(Konva._TextPath, 'sentence_author', 0);
        Factory.addGetterSetter(Konva._TextPath, 'textJSON', {});
        Factory.addGetterSetter(Konva._TextPath, 'parentWidth', 0);
        Factory.addGetterSetter(Konva._TextPath, 'parentHeight', 0);
        Factory.addGetterSetter(Konva._TextPath, 'texture_src', '');
        Factory.addGetterSetter(Konva._TextPath, 'texture_type', '');
        Factory.addGetterSetter(Konva._TextPath, 'rotate_texture', '0');
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowEnabled', false);
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowColor', '#000000');
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowOffsetX', '1');
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowOffsetY', '1');
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowOpacity', '0.5');
        Factory.addGetterSetter(Konva._TextPath, 'innerShadowBlur', '2');
        Factory.addGetterSetter(Konva._TextPath, 'ellipseOffset', '0');
    }
}